import SendOnboardingLinkModal from './SendOnboardingLinkModal';

export default SendOnboardingLinkModal;
